import React from "react";
import '../styles/hero.scss';

import { Typewriter } from 'react-simple-typewriter'
// import brand1 from "../images/brands/backofficefx.png";
// import brand2 from "../images/brands/jojointernational.png";
// import brand3 from "../images/brands/milogistics.png";
// import brand4 from "../images/brands/resumegory.png";
// // import brand5 from "../images/brands/roshan.png";
// import brand6 from "../images/brands/innovationwavex.png";

  
import pdfFile from './../images/YashalAli_CV.pdf'; // Adjust the path as needed


export default function Hero() {

    let heroWords = [
        'Web Developers |',
        ' Problem Solver'
    ];
    
    // Nav Link Scroll To Section
    let navLinkScrollToSection = (section: any) => {
        let element = document.getElementById(section);
        element?.scrollIntoView({ behavior: "smooth" });
    };
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = pdfFile;
        link.download = 'YashalAli_CV.pdf'; // The name of the file once downloaded
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
    return (
        <section id="home" className="hero">
            <div className="bg"></div>
            <div className="container">
                <div className="d-flex flex-column justify-content-center align-items-center gap-md-4 gap-2 my-2">
                    <h1 className="h3 text-center m-0">
                      Hi, I'm  <span className="text-gradient h1">Yashal Ali Farooqui</span><br/>
                      
                       <span
                            className="text-gradient typed-text">
                                <span>Frontend Developer | </span>
                            <Typewriter
                                words={heroWords}
                                typeSpeed={50}
                                deleteSpeed={50}
                                delaySpeed={1000}
                                cursor={false}
                                loop={true}
                            />
                          
                        </span>
                        <br/>
                        I build scalable web applications and create seamless user experiences. Let's collaborate to bring your ideas to life.
                    </h1>
                    <h2 className="h4 fw-normal text-center m-0">
                    Explore my portfolio to see my work, review my experience, or download my resume. Let’s connect and discuss how we can collaborate on innovative projects.
                    </h2>
                    <div className="d-flex justify-content-center m-0 mt-2 mt-md-1 mb-2 ">
                        <button type="button" onClick={() => navLinkScrollToSection('audit')} className="btn btn-outline-primary btn-outline-theme">Get in Touch !</button>
                        <button type="button" onClick={handleDownload} className="btn btn-outline-primary btn-outline-theme mx-2 ">Get My CV</button>
                    </div>
                    {/* <figure className="d-flex flex-wrap align-items-center justify-content-center">
                        <img src={brand1} className="brand-img" alt="Brand" />
                        <span className="divider"></span>
                        <img src={brand2} className="brand-img" alt="Brand" />
                        <span className="divider"></span>
                        <img src={brand3} className="brand-img" alt="Brand" />
                        <span className="divider"></span>
                        <img src={brand4} className="brand-img" alt="Brand" />
                    </figure> */}
                </div>
            </div>
        </section>
    );
}